import http from './http'

class AssignmentRequest {
  fetch () {
    return http.get('/assignment_requests')
  }

  status () {
    return http.get('/dashboard/assignors/status')
  }

  save (payload) {
    return http.post('/assignment_requests', payload)
  }

  accept (id) {
    return http.put(`/dashboard/payers/assignment_requests/${id}/approve_assignor_assignment_request`)
  }

  reject (id) {
    return http.put(`/dashboard/payers/assignment_requests/${id}/reject_assignor_assignment_request`)
  }
}

export default new AssignmentRequest()



// WEBPACK FOOTER //
// ./src/services/assignment_request.js